export const additionalSkills = [
  {
    id: '1',
    image: '/node.svg',
    title: 'NodeJS',
    href: 'https://nodejs.org/en',
  },
  {
    id: '2',
    image: '/nest.png',
    title: 'NestJS',
    href: 'https://nestjs.com/',
  },
  {
    id: '3',
    image: '/mongo.svg',
    title: 'MongoDB',
    href: 'https://www.mongodb.com/',
  },
  {
    id: '4',
    image: '/redux.svg',
    title: 'Redux',
    href: 'https://redux-toolkit.js.org/',
  },
  {
    id: '5',
    image: '/zustand.jpg',
    title: 'Zustand',
    href: 'https://zustand-demo.pmnd.rs/',
  },
  {
    id: '6',
    image: '/ant-design.png',
    title: 'Ant Design',
    href: 'https://ant.design/',
  },
  {
    id: '7',
    image: 'https://v4.material-ui.com/static/logo.png',
    title: 'MUI',
    href: 'https://mui.com/material-ui/',
  },
  {
    id: '8',
    image:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/b/b2/Bootstrap_logo.svg/640px-Bootstrap_logo.svg.png',
    title: 'Bootstrap',
    href: 'https://getbootstrap.com/',
  },
  {
    id: '9',
    image: '/figma.svg',
    title: 'Figma',
    href: 'https://www.figma.com/',
  },
  {
    id: '10',
    image: 'https://socket.io/images/logo.svg',
    title: 'Socket IO',
    href: 'https://socket.io/',
  },
  {
    id: '11',
    image: 'https://git-scm.com/images/logos/downloads/Git-Icon-1788C.png',
    title: 'Git',
    href: 'https://www.git-scm.com/',
  },
  {
    id: '12',
    image:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/Firebase_icon.svg/2048px-Firebase_icon.svg.png',
    title: 'Firebase',
    href: 'https://firebase.google.com/',
  },
  {
    id: '13',
    image: 'https://www.svgrepo.com/show/327408/logo-vercel.svg',
    title: 'Vercel',
    href: 'https://vercel.com/',
  },
];
